import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';
import PageLayout from '../components/PageLayout';
import Button from '../components/Button';
import Alert from '../components/Alert';

export default function EnterpriseRegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', code: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.code.trim()) { setError('请填写企业名称和企业码'); return; }
    if (!/^[A-Za-z0-9]{4,8}$/.test(form.code)) {
      setError('企业码需为 4-8 位字母数字');
      return;
    }
    setLoading(true); setError('');
    try {
      await client.post('/enterprises/register/', form);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || JSON.stringify(err.response?.data) || '注册失败，请重试');
    } finally { setLoading(false); }
  };

  return (
    <PageLayout>
      <div style={{ maxWidth: 480, margin: '60px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-md)', border: '1px solid var(--color-border)', padding: '40px 36px' }}>
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>🎉</div>
              <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>注册申请已提交</h2>
              <p style={{ color: 'var(--color-text-secondary)', lineHeight: 1.7, marginBottom: 24 }}>
                您的企业 <strong>{form.name}</strong> 注册申请已提交，企业码为 <code style={{ background: '#f1f5f9', padding: '2px 6px', borderRadius: 4 }}>{form.code.toUpperCase()}</code>。
                <br />管理员审核激活后，您即可使用企业码邀请团队成员参与测评。
              </p>
              <Button onClick={() => navigate('/')}>返回首页</Button>
            </div>
          ) : (
            <>
              <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--color-primary)', marginBottom: 8 }}>企业注册申请</h1>
              <p style={{ color: 'var(--color-text-secondary)', fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
                注册企业账号后，您可以设置团队测评规则、统一管理成员测评数据。提交后需等待平台管理员审核激活。
              </p>

              {error && <Alert type="error" style={{ marginBottom: 16 }}>{error}</Alert>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-text)', display: 'block', marginBottom: 6 }}>
                    企业 / 组织名称 *
                  </label>
                  <input
                    value={form.name}
                    onChange={e => set('name', e.target.value)}
                    placeholder="例：北京科技有限公司"
                    style={inputStyle}
                  />
                </div>

                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-text)', display: 'block', marginBottom: 6 }}>
                    企业码 * <span style={{ fontWeight: 400, color: 'var(--color-text-secondary)' }}>(4-8 位字母数字，用于邀请成员)</span>
                  </label>
                  <input
                    value={form.code}
                    onChange={e => set('code', e.target.value.toUpperCase())}
                    placeholder="例：TECH2024"
                    maxLength={8}
                    style={{ ...inputStyle, fontFamily: 'monospace', letterSpacing: 2 }}
                  />
                  <p style={{ fontSize: 11, color: 'var(--color-text-muted)', marginTop: 4 }}>
                    企业码一旦设定不可修改，请谨慎选择
                  </p>
                </div>

                <div style={{ background: '#eff6ff', borderRadius: 8, padding: '12px 16px', fontSize: 13, color: '#1d4ed8', lineHeight: 1.7 }}>
                  <strong>注意事项：</strong><br />
                  • 提交后将自动成为该企业管理员<br />
                  • 管理员审核通过后方可使用<br />
                  • 审核通常在 1 个工作日内完成
                </div>

                <Button type="submit" fullWidth loading={loading}>提交注册申请</Button>
              </form>
            </>
          )}
        </div>
      </div>
    </PageLayout>
  );
}

const inputStyle = {
  width: '100%', padding: '11px 14px', borderRadius: 'var(--radius-md)',
  border: '1.5px solid var(--color-border)', fontSize: 14,
  color: 'var(--color-text)', boxSizing: 'border-box', outline: 'none',
};
